import {observer} from "mobx-react";
import React from "react";
import {ContentFilter, ContentInput, ContentInputAndFilter, ContentSelectAndCheckBox,} from "./styled";
import SelectRangeDate from "@dropDesk/presentation/components/dates/select_range_date";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {PeriodEnum} from "@dropDesk/utils/helpers/common";
import {UserRole} from "@dropDesk/domain/entities/user/user_enum";
import SelectSearchUser from "@dropDesk/presentation/components/inputs/select_search_users";
import {UserEntity} from "@dropDesk/domain/entities/user/user.entity";


const SearchBar = observer((
    {
        loading,
        user,
        removeFilter,
        getReportTicketRate,
        setPeriod,
        period,
        labelPeriodCustom,
        onSelectUser
    }: {
        loading: boolean,
        user: UserEntity | null,
        removeFilter: () => void,
        getReportTicketRate: () => void,
        period: Array<Date> | null;
        setPeriod: (period: Array<Date> | null, label: PeriodEnum) => void
        labelPeriodCustom: PeriodEnum
        onSelectUser: (user: UserEntity | null) => void,
    }
) => {

    const appController = useInjection(AppController);
    const colors = appController.theme.colorScheme;

    const removeAllFilters = () => {
        removeFilter();
    }

    return (
        <ContentFilter background={colors.onBackground}>
            <ContentInputAndFilter>
                <ContentInput>
                    <SelectRangeDate
                        size={37}
                        value={period}
                        allowClear={true}
                        onChange={(arrayDate, label) => {
                            setPeriod(arrayDate, label);
                            getReportTicketRate();
                        }}
                        labelPeriodCustom={labelPeriodCustom}
                    />
                </ContentInput>


                <ContentSelectAndCheckBox>
                    <div style={{display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center'}}>

                        <SelectSearchUser
                            size={37}
                            useRemoveFilter={!!user}
                            label={'Filtrar por atendente'}
                            placeHolder={"Selecione o atendente"}
                            handleSelectUser={(value, user) => {
                                onSelectUser(user ?? null);
                            }}
                            value={user ? {value: user.id, label: user.name} : undefined}
                            role={UserRole.attendant}
                            disabled={loading}
                        />
                    </div>

                </ContentSelectAndCheckBox>

            </ContentInputAndFilter>
        </ContentFilter>
    )
})
export default SearchBar;
